import { useUpdateDemoMutation } from "../../api/api-hooks";
import { DemosAddItemForm } from "./demosTypes";

const useDemosItemUpdater = () => {
  const [updateDemo] = useUpdateDemoMutation();
  return (item: DemosAddItemForm, id: number) => {
    if (item.company === null || item.company === undefined)
      return { error: { data: { message: "Missing required fields" } } };
    if (!item.inventoryHardware) {
    }
    return updateDemo({
      id: id,
      updateDemoDto: {
        inventoryHardwareId: item.inventoryHardware
          ? item.inventoryHardware.id
          : null,
        contactName: item.contactName,
        companyId: item.company.id,
        shipDate: item.shipDate ? item.shipDate : null,
        startDate: item.startDate ? item.startDate : null,
        endDate: item.endDate ? item.endDate : null,
        softwareId: item.software ? item.software.id : null,
        softwareVersionId: item.softwareVersion
          ? item.softwareVersion.id
          : null,
        id,
      },
    });
  };
};

export default useDemosItemUpdater;
